import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// VAPID key for FCM (Web Push certificates)
export const VAPID_KEY = import.meta.env.VITE_VAPID_KEY;

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messaging = null;

try {
  // Only initialize messaging if supported (not in all browsers)
  if ('Notification' in window && 'serviceWorker' in navigator) {
    messaging = getMessaging(app);
  } else {
    console.warn('Firebase Messaging not supported in this browser');
  }
} catch (error) {
  console.error('Error initializing Firebase Messaging:', error);
}

export { app, messaging, getToken, onMessage };
